// bootstrap
import { Tooltip } from "react-bootstrap";

// TOOLTIPS
// delete
export const renderTooltipDelete = (props) => (
    <Tooltip {...props}>Delete Coupon</Tooltip>
);

// edit
export const renderTooltipEdit = (props) => <Tooltip {...props}>Edit Coupon</Tooltip>;

// edit
export const renderTooltipAutoApplyInfo = (props) => <Tooltip {...props}>The coupon will apply automatically when a user meets the requirements.</Tooltip>;
